import { render, staticRenderFns } from "./box1.vue?vue&type=template&id=c58a3858&scoped=true&"
import script from "./box1.vue?vue&type=script&lang=ts&"
export * from "./box1.vue?vue&type=script&lang=ts&"
import style0 from "./box1.vue?vue&type=style&index=0&id=c58a3858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58a3858",
  null
  
)

export default component.exports